import usersApi from './resources/users';
import authApi from './resources/auth';

export default {
  users: usersApi,
  auth: authApi,
};
